import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../../Common';
import ValidatedSelect from '../../common/forms/ValidatedSelect';
import { FormContext } from '../../common/forms/FormElements';

export const DispatchLocation = () => {
    const { setFieldValue } = useContext(FormContext);
    const { data, isLoading } = useQuery({
        queryKey: ['dispatchLocations'],
        queryFn: () => httpClient.js(ApiRoutes.typeAheads.selectableDispatchLocations()),
    });

    return (
        <ValidatedSelect
            id="dispatchLocationId"
            name="dispatchLocationId"
            label="Dispatch Location"
            options={data}
            isLoading={isLoading}
            required
            error="A dispatch location is required."
            onChange={() => {
                setFieldValue('companyId', null);
                setFieldValue('contractId', null);
                setFieldValue('projectId', null);
            }}
        />
    );
};
